import isPromise from 'is-promise';
import { Dispatch, AnyAction } from 'redux';
import DataService from '../../services/data-service';
import { CustomObject } from '../../types/data';
// import { isProduction } from '../../config/secrets';
import { last } from 'lodash';

const ErrorMiddleware = () => {
  return (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    if (!isPromise(action.payload) && action.meta?.__PARSABLE__) {
      try {
        const status = last<string>(action.type.split(':'));
        const isSuccess = DataService.isSuccess(action.payload.data);
        const payload = isSuccess
          ? DataService.parseData(action.payload.data)
          : DataService.parseErrors(action.payload.data);

        if (isSuccess && status !== 'success') {
          let type = action.type.split(':');
          type[type?.length - 1] = 'error';
          type = type.join(':');

          return next({ ...action, type, payload });
        }

        return next({ ...action, payload });
      } catch (e) {
        console.error('log: error: ErrorMiddleware ', e, action);
        throw e;
      }
    }

    if (isPromise(action.payload) && action.meta.__HANDLE_ERROR__) {
      return next(action)
        .then((payload: CustomObject = {}) => {
          return { payload: payload.value };
        })
        .catch((payload: CustomObject = {}) => {
          if (payload instanceof Error) {
            // if (isProduction) {
            console.error('__HANDLED_ERROR__\n', payload);
            // }

            return {
              payload: {
                message: payload.message,
                originalError: payload,
              },
              __HANDLED_ERROR__: true,
              __NATIVE_ERROR__: true,
            };
          }

          return {
            payload: payload,
            __HANDLED_ERROR__: true,
          };
        });
    }

    return next(action);

    // If not a promise, continue on
    // if (!isPromise(action.payload)) {
    //   return next(action);
    // }

    /*
     * Another solution would would be to include a property in `meta`
     * and evaulate that property.
     *
     * if (action.meta.globalError === true) {
     *   // handle error
     * }
     *
     * The error middleware serves to dispatch the initial pending promise to
     * the promise middleware, but adds a `catch`.
     */

    // Dispatch initial pending promise, but catch any errors
    // return next(action).catch(error => {
    //   console.log('parse error', error);
    //   return error;
    // });
  };
};

export default ErrorMiddleware;
